import { render } from "./ProsesPenilaianLKE.vue?vue&type=template&id=fed22b96"
import script from "./ProsesPenilaianLKE.vue?vue&type=script&lang=js"
export * from "./ProsesPenilaianLKE.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__